import { render, staticRenderFns } from "./ManageStatisticDia.vue?vue&type=template&id=4194fe68&scoped=true"
import script from "./ManageStatisticDia.vue?vue&type=script&lang=js"
export * from "./ManageStatisticDia.vue?vue&type=script&lang=js"
import style0 from "./ManageStatisticDia.vue?vue&type=style&index=0&id=4194fe68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4194fe68",
  null
  
)

export default component.exports